import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsItchDotIoComponent } from './simple-icons-itch-dot-io.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsItchDotIoComponent ],
    exports:      [ SimpleIconsItchDotIoComponent ],
    bootstrap:    []
})
export class SimpleIconsItchDotIoModule {}
